import { FC } from "react";
import { Modal } from "components/atoms/Modal";
import { Span, SubTitle } from "utils/styling/typography.styled";
import { HELP_VIDEO_URL } from "utils/urlConstants";
import * as Styled from "./QuestionModal.styled";
type QuestionModalProps = {
  isOpen: boolean;
  handleBackdropClick: () => void;
};
const QuestionModal: FC<QuestionModalProps> = ({
  isOpen,
  handleBackdropClick
}) => {
  return <Modal open={isOpen} handleBackdropClick={handleBackdropClick} data-sentry-element="Modal" data-sentry-component="QuestionModal" data-sentry-source-file="index.tsx">
            <Styled.QuestionModalContent data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <Styled.TextContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <SubTitle data-sentry-element="SubTitle" data-sentry-source-file="index.tsx">
                        How To Export Your D&D Character Sheet as PDF from D&D
                        Beyond
                    </SubTitle>
                    <ul>
                        <li>
                            <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Visit D&D Beyond.</Span>
                        </li>
                        <li>
                            <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">
                                Click on the Character you wish to export.
                            </Span>
                        </li>
                        <li>
                            <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Select the Manage option.</Span>
                        </li>
                        <li>
                            <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">
                                Click on Export to PDF to generate the PDF.
                            </Span>
                        </li>
                        <li>
                            <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Save the PDF to your device.</Span>
                        </li>
                        <li>
                            <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">
                                Alternatively, copy the PDF URL if available.
                            </Span>
                        </li>
                        <li>
                            <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">
                                Navigate to CharGen&apos;s Choose File option.
                            </Span>
                        </li>
                        <li>
                            <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">
                                If you saved the PDF, locate and select it.
                            </Span>
                        </li>
                        <li>
                            <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">
                                Or, paste the copied PDF URL into the URL box.
                            </Span>
                        </li>
                    </ul>
                </Styled.TextContainer>
                <Styled.VideoContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <video src={HELP_VIDEO_URL} controls />
                </Styled.VideoContainer>
            </Styled.QuestionModalContent>
        </Modal>;
};
export default QuestionModal;